/* eslint-disable import/prefer-default-export */
import { userActions } from '../rootTypes';

export const fetchUser = () => ({
  type: userActions.fetchRequest,
});

export const userLogout = () => {
  localStorage.removeItem('user_uuid');
  localStorage.removeItem('youstycareerchoiceradarstate');
  return {
    type: userActions.logout,
  };
};
